export const getLibraryIdFromUrl = (url: string): string => {
    let libraryId = '';

    const splittedUrl = url.split('/');
    const libraryIdIndex = splittedUrl[5];

    if (libraryIdIndex) {
        libraryId = libraryIdIndex;
    }

    return libraryId;
};
